import { getItem, setItem } from "./LocalStorage.js";

export function interviewAccountReturnPath(explicit = null) {
  for (const value of [explicit, getItem("targetUrl")]) {
    if (
      typeof value === "string" &&
      /^\/schedule-interview\/[a-f0-9-]{36}\?accountReady=1$/i.test(value)
    )
      return value;
  }
  return null;
}

export function interviewAccountReturnUuid(explicit = null) {
  return interviewAccountReturnPath(explicit)?.split("/")[2]?.split("?")[0];
}

export function consumeInterviewAccountReturn(explicit = null) {
  const path = interviewAccountReturnPath(explicit);
  if (path) setItem("targetUrl", "", 0);
  return path;
}
